/**
 * Product Media Gallery — syncs thumbnails with slideshow-component.
 *
 * Attaches to any <media-gallery> with data-presentation="gallery".
 * The slideshow-component handles swipe, drag, and arrow navigation.
 * This script wires thumbnail clicks/keyboard to slideshow.select()
 * and keeps thumbnail active state in sync via the slideshow:select event.
 */
(function () {
  function init(gallery) {
    const thumbs = gallery.querySelector('.product-gallery__thumbs');
    const slideshow = gallery.querySelector('slideshow-component');
    if (!thumbs) return;

    // Thumbnail click → select slide in slideshow
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-gallery__thumb');
      if (!btn) return;
      var index = parseInt(btn.dataset.mediaIndex, 10);
      if (slideshow && slideshow.select) {
        slideshow.select(index, null, { animate: false });
      }
    });

    // Keyboard nav on thumbnails
    thumbs.addEventListener('keydown', function (e) {
      var current = gallery.querySelector('.product-gallery__thumb--active');
      if (!current) return;
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        next = current.nextElementSibling;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        next = current.previousElementSibling;
      }
      if (next && next.classList.contains('product-gallery__thumb')) {
        e.preventDefault();
        next.focus();
        var index = parseInt(next.dataset.mediaIndex, 10);
        if (slideshow && slideshow.select) {
          slideshow.select(index, null, { animate: false });
        }
      }
    });

    // Slideshow navigation (swipe/arrows) → sync thumbnails
    if (slideshow) {
      slideshow.addEventListener('slideshow:select', function (e) {
        syncThumbnails(gallery, e.detail.index);
      });
    }
  }

  function syncThumbnails(gallery, index) {
    var thumbs = gallery.querySelectorAll('.product-gallery__thumb');
    for (var i = 0; i < thumbs.length; i++) {
      var isActive = i === index;
      thumbs[i].classList.toggle('product-gallery__thumb--active', isActive);
      thumbs[i].setAttribute('aria-selected', String(isActive));
      thumbs[i].setAttribute('tabindex', isActive ? '0' : '-1');
    }
  }

  // Initialize on load
  document.querySelectorAll('media-gallery[data-presentation="gallery"]').forEach(init);

  // Re-initialize after variant update replaces the gallery element
  new MutationObserver(function (mutations) {
    for (var mi = 0; mi < mutations.length; mi++) {
      var added = mutations[mi].addedNodes;
      for (var ni = 0; ni < added.length; ni++) {
        var node = added[ni];
        if (node.nodeType === 1) {
          var gallery = node.matches && node.matches('media-gallery[data-presentation="gallery"]')
            ? node
            : node.querySelector && node.querySelector('media-gallery[data-presentation="gallery"]');
          if (gallery) init(gallery);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
